export default __webpack_public_path__ + "static/media/Armbands of the Exorcist.7b41c060.jpg";